import React from 'react';
import dayjs from 'dayjs';

const OV = { position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const MO = { background: '#fff', borderRadius: 8, maxWidth: 420, width: 'calc(100% - 32px)', maxHeight: '90vh', overflowY: 'auto' };

const OtDetailDialog = React.memo(function OtDetailDialog({ open, onClose, otDvData, month, year }) {
  const ot = otDvData?.otReq;
  const mn = otDvData?.manualEntry;
  const checkin = otDvData?.checkin;
  const hasApproved = ot?.total_hours > 0;
  // OT ที่ไม่ใช่ APPROVE (รออนุมัติ/ไม่อนุมัติ) ถูกส่งมาแสดงอย่างเดียว ไม่นำไปคำนวณ
  const notApproved = hasApproved && !!ot.status && ot.status !== 'APPROVE';
  const statusText = ot?.status === 'PENDING' ? 'รออนุมัติ' : ot?.status === 'REJECT' ? 'ไม่อนุมัติ' : ot?.status;
  const hasManual = mn?.ot_hours > 0;
  const hrRate = (checkin?.salary_per_day || 0) / 8;

  const otAmt = hasApproved ? ot.total_price || ot.total_hours * (ot.rate || 1.5) * hrRate : 0;
  const otRateNum = hasApproved ? ot.rate || 1.5 : 0;
  const otRateLabel = otRateNum >= 3 ? '×3.0' : otRateNum >= 2 ? '×2.0' : '×1.5';
  const otRateSub = otRateNum >= 3 ? 'วันหยุดนักขัตฤกษ์' : otRateNum >= 2 ? 'วันหยุด' : 'วันทำงาน';

  const mnRate = hasManual ? mn.ot_rate || 1.5 : 0;
  const mnAmt = hasManual ? (mn.ot_amount != null ? mn.ot_amount : mn.ot_hours * mnRate * hrRate) : 0;
  const mnRateLabel = mnRate >= 3 ? '×3.0' : mnRate >= 2 ? '×2.0' : '×1.5';
  const mnRateSub = mnRate >= 3 ? 'วันหยุดนักขัตฤกษ์' : mnRate >= 2 ? 'วันหยุด' : 'วันทำงาน';

  const dateStr = otDvData?.day
    ? `${String(otDvData.day).padStart(2, '0')}/${String(month + 1).padStart(2, '0')}/${year}`
    : '';

  const projectStr = checkin?.project_name
    ? `${checkin.project_name}${checkin.project_number ? ` (${checkin.project_number})` : ''}`
    : null;

  // ช่วงเวลา OT แบบ manual — ไม่มีเวลาเข้า-ออกจริง จึงสมมติเริ่มนับจาก 17:00 (เลิกงาน) + ตามจำนวนชั่วโมงที่เพิ่ม
  const mnTimeStr = hasManual && otDvData?.day
    ? (() => {
        const base = dayjs(
          `${year}-${String(month + 1).padStart(2, '0')}-${String(otDvData.day).padStart(2, '0')} 17:00`,
        );
        const end = base.add(mn.ot_hours * 60, 'minute');
        return `${base.format('HH:mm')} — ${end.format('HH:mm')}`;
      })()
    : null;

  if (!open) return null;
  return (
    <div style={OV} onClick={onClose}>
      <div style={MO} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div style={{ background: 'linear-gradient(135deg, #ea580c 0%, #f97316 60%, #fb923c 100%)', padding: '16px 20px 20px' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 8 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                <span style={{ fontSize: '0.85rem' }}>⏱</span>
                <span style={{ fontWeight: 700, fontSize: '1rem', color: '#fff' }}>รายละเอียด OT</span>
              </div>
              <div style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.9)', fontWeight: 600 }}>{otDvData?.empName}</div>
              {dateStr && <div style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.7)', marginTop: 2 }}>📅 {dateStr}</div>}
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              {hasApproved && (
                <span style={{ padding: '2px 10px', background: 'rgba(255,255,255,0.2)', borderRadius: 12, border: '1px solid rgba(255,255,255,0.3)', fontSize: '0.65rem', fontWeight: 700, color: '#fff' }}>
                  {notApproved ? `✗ ${statusText}` : '✓ อนุมัติ'}
                </span>
              )}
              {hasManual && (
                <span style={{ padding: '2px 10px', background: 'rgba(255,255,255,0.15)', borderRadius: 12, border: '1px solid rgba(255,255,255,0.25)', fontSize: '0.65rem', fontWeight: 700, color: '#fff' }}>✎ HR</span>
              )}
            </div>
          </div>

          {(hasApproved || hasManual) && (
            <div style={{ display: 'flex', gap: 8 }}>
              {[
                { label: 'ชั่วโมง OT', value: hasApproved ? `${ot.total_hours}` : `${mn.ot_hours}`, unit: 'ชม.' },
                { label: 'อัตรา', value: hasApproved ? otRateLabel : mnRateLabel, unit: hasApproved ? otRateSub : mnRateSub },
                { label: 'ค่า OT', value: `฿${(hasApproved ? otAmt : mnAmt).toLocaleString('th-TH', { maximumFractionDigits: 0 })}`, unit: '' },
              ].map(({ label, value, unit }) => (
                <div key={label} style={{ flex: 1, background: 'rgba(255,255,255,0.15)', borderRadius: 6, padding: '8px 4px', textAlign: 'center' }}>
                  <div style={{ fontSize: '0.6rem', color: 'rgba(255,255,255,0.75)', fontWeight: 500, marginBottom: 2 }}>{label}</div>
                  <div style={{ fontSize: '1rem', fontWeight: 800, color: '#fff', lineHeight: 1.1 }}>{value}</div>
                  {unit && <div style={{ fontSize: '0.6rem', color: 'rgba(255,255,255,0.7)' }}>{unit}</div>}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* OT Approved */}
        {hasApproved && (() => {
          const timeStr = ot.startTime && ot.endTime ? `${dayjs(ot.startTime).format('HH:mm')} — ${dayjs(ot.endTime).format('HH:mm')}` : null;
          const requesterName = ot.created_by?.display_name || ot.employee_name || null;
          const rows = [
            projectStr && { icon: '🏗', label: 'โครงการ', value: projectStr },
            timeStr && { icon: '🕐', label: 'เวลา OT', value: timeStr },
            ot.description && { icon: '📝', label: 'รายละเอียด', value: ot.description },
            requesterName && { icon: '👤', label: 'ผู้ขอ OT', value: requesterName },
            ot.createdAt && { icon: '📅', label: 'วันที่ขอ', value: dayjs(ot.createdAt).format('DD MMM YY, HH:mm') },
            ot.last_edited_by?.display_name && { icon: '✎', label: 'แก้ไขโดย', value: `${ot.last_edited_by.display_name}${ot.last_edited_at ? ` · ${dayjs(ot.last_edited_at).format('DD/MM/YY')}` : ''}` },
          ].filter(Boolean);
          return (
            <div style={{ padding: '16px 20px', paddingBottom: hasManual ? 12 : 16 }}>
              <div style={{ fontSize: '0.65rem', fontWeight: 700, color: '#ea580c', letterSpacing: '0.06em', marginBottom: 8 }}>
                {notApproved ? `OT ${ot.status} (${statusText} — ไม่นำไปคำนวณ)` : 'OT APPROVED'}
              </div>
              {rows.map(({ icon, label, value }, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '6px 0', borderBottom: i < rows.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                  <span style={{ fontSize: '0.85rem', flexShrink: 0, width: 18, textAlign: 'center' }}>{icon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '0.65rem', color: '#9ca3af', fontWeight: 600, letterSpacing: '0.04em' }}>{label}</div>
                    <div style={{ fontSize: '0.82rem', color: '#111827', fontWeight: 500, wordBreak: 'break-word' }}>{value}</div>
                  </div>
                </div>
              ))}
              <div style={{ marginTop: 12, padding: '8px 12px', background: '#fff7ed', borderRadius: 6, border: '1px solid #fed7aa', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '0.72rem', color: '#9a3412' }}>{ot.total_hours} ชม. × {otRateLabel} × ฿{hrRate.toFixed(2)}/ชม.</span>
                <span style={{ fontSize: '0.9rem', fontWeight: 800, color: '#c2410c' }}>฿{otAmt.toLocaleString('th-TH', { minimumFractionDigits: 2 })}</span>
              </div>
            </div>
          );
        })()}

        {hasApproved && hasManual && (
          <div style={{ padding: '0 20px' }}>
            <hr style={{ border: 'none', borderTop: '1px dashed #e5e7eb', margin: '4px 0' }} />
            <div style={{ textAlign: 'center', fontSize: '0.65rem', color: '#9ca3af', margin: '-10px 0 4px' }}>
              <span style={{ background: '#fff', padding: '0 8px' }}>และ</span>
            </div>
          </div>
        )}

        {/* Manual OT */}
        {hasManual && (() => {
          const mnRows = [
            projectStr && { icon: '🏗', label: 'โครงการ', value: projectStr },
            mnTimeStr && { icon: '🕐', label: 'เวลา OT', value: mnTimeStr },
            { icon: '⏱', label: 'ชั่วโมง OT', value: `${mn.ot_hours} ชม.` },
            { icon: '📊', label: 'อัตรา', value: `${mnRateLabel} ${mnRateSub}` },
            { icon: '👤', label: 'ผู้ขอ OT', value: mn.edited_by || '—' },
            mn.edited_at && { icon: '📅', label: 'วันที่ขอ', value: dayjs(mn.edited_at).format('DD MMM YY, HH:mm') },
          ].filter(Boolean);
          return (
          <div style={{ padding: '16px 20px' }}>
            <div style={{ fontSize: '0.65rem', fontWeight: 700, color: '#1d4ed8', letterSpacing: '0.06em', marginBottom: 8 }}>HR MANUAL OT</div>
            {mnRows.map(({ icon, label, value }, i, arr) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '6px 0', borderBottom: i < arr.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                <span style={{ fontSize: '0.85rem', flexShrink: 0, width: 18, textAlign: 'center' }}>{icon}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '0.65rem', color: '#9ca3af', fontWeight: 600 }}>{label}</div>
                  <div style={{ fontSize: '0.82rem', color: '#111827', fontWeight: 500 }}>{value}</div>
                </div>
              </div>
            ))}
            <div style={{ marginTop: 12, padding: '8px 12px', background: '#eff6ff', borderRadius: 6, border: '1px solid #bfdbfe', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '0.72rem', color: '#1e40af' }}>
                {mn.ot_hours} ชม. × {mnRateLabel} × ฿{hrRate.toFixed(2)}/ชม.
                {mn.ot_amount != null && <span style={{ marginLeft: 4, opacity: 0.7 }}>(กำหนดเอง)</span>}
              </span>
              <span style={{ fontSize: '0.9rem', fontWeight: 800, color: '#1d4ed8' }}>฿{mnAmt.toLocaleString('th-TH', { minimumFractionDigits: 2 })}</span>
            </div>
          </div>
          );
        })()}

        {!hasApproved && !hasManual && (
          <div style={{ padding: '32px 20px', textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', marginBottom: 8 }}>🕐</div>
            <div style={{ fontSize: '0.875rem', color: '#9ca3af' }}>ไม่มีข้อมูล OT</div>
          </div>
        )}

        <div style={{ padding: '10px 20px 16px', display: 'flex', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '6px 20px', borderRadius: 6, border: 'none', backgroundColor: '#ea580c', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '0.8rem' }}>
            ปิด
          </button>
        </div>
      </div>
    </div>
  );
});

export default OtDetailDialog;
